// extracted by mini-css-extract-plugin
module.exports = {"message":"message_message__fzSza","message__heading":"message_message__heading__77fBa","message__text":"message_message__text__W3xrn"};